module.exports = __webpack_public_path__ + "img/LensAdvisors_cropped.cda710d7.svg";